// @ts-nocheck
/* eslint-disable */
import Content from './content';
import { node, isInViewport } from "~/util/dom";

const SCROLL_TO = 33;

export default class Partner extends Content {
	constructor(data, options) {
		super(data, options);

		this._scrollWasBind = false;
		this._scrollId = null;

		setTimeout(() => {
			if (isInViewport(this._dom.list)) {
				this._impressAnalytics();
			} else {
				this._scrollWasBind = true;
				Mapy.getComponent("layout").getScrollNode().addEventListener("scroll", this);
				document.addEventListener("scroll", this, false);
			}
		}, 100);
	}

	destroy() {
		this._removeScrollEvent();
	}

	handleEvent(e) {
		switch (e.type) {
			case "scroll":
				if (this._scrollId) {
					clearTimeout(this._scrollId);
					this._scrollId = null;
				}

				this._scrollId = setTimeout(() => {
					this._scrollId = null;

					if (isInViewport(this._dom.list)) {
						this._impressAnalytics();
						this._removeScrollEvent();
					}

				}, SCROLL_TO);
				break;
		}
	}

	_build() {
		this._dom.container.classList.add("content-partners");

		const header = node("h3", { textContent: this._data.label });
		const list = node("div");
		this._dom.container.append(header, list);
		this._dom.list = list;

		let d = this._data.value || [];

		for (let i = 0; i < d.length; i++) {
			let item = d[i];
			let name = item.name || "";
			let link = Mapy.Util.node("a", { href: item.url, target: "_blank" });
			link.setAttribute("data-log-text", name);
			link.setAttribute("data-log-section", "partners");
			link.setAttribute("data-log-id", this._options.data.id);
			link.setAttribute("data-log-source", this._options.data.source);
			link.setAttribute("data-log-typeid", this._options.data.typeId);
			let img = new Image();
			img.crossOrigin = "anonymous";
			img.src = item.image;
			img.alt = name;

			if (name) {
				img.title = name;
			}

			link.append(img);
			list.append(link);
		}
	}

	_impressAnalytics() {
		Mapy.getComponent("logger").log("partners_show", {
			id: this._options.data.id,
			source: this._options.data.source,
			typeid: this._options.data.typeId,
			section: "partners",
		});
	}

	_removeScrollEvent() {
		if (!this._scrollWasBind) return;

		Mapy.getComponent("layout").getScrollNode().removeEventListener("scroll", this);
		document.removeEventListener("scroll", this, false);
		this._scrollWasBind = false;
	}
}
